/* eslint-disable no-await-in-loop */
/* eslint-disable no-restricted-syntax */
import u from 'umbrellajs';
import {
	getDefaultTitleForSections,
	getSocialMediaLinks,
	getTelegramUniversalLink,
	getWhatsappUniversalLink
} from './utils';

export const getRandomInt = (min, max) => {
	min = Math.ceil(min);
	max = Math.floor(max);
	return Math.floor(Math.random() * (max - min)) + min; // The maximum is exclusive and the minimum is inclusive
};

export const isVisible = e => {
	return !!(e.offsetWidth || e.offsetHeight || e.getClientRects().length);
};

export function checkElement(selector) {
	// eslint-disable-next-line
	return new Promise(function(resolve, reject) {
		const element = document.querySelector(selector);

		if (element) {
			resolve(element);
			return;
		}

		const observer = new MutationObserver(function(mutations) {
			mutations.forEach(function(mutation) {
				const nodes = Array.from(mutation.addedNodes);
				for (const node of nodes) {
					if (node.matches && node.matches(selector)) {
						observer.disconnect();
						resolve(node);
						return;
					}
				}
			});
		});

		observer.observe(document.documentElement, { childList: true, subtree: true });
	});
}

export const checkWindowVariableChangedToTrue = async variable => {
	// while (window[variable] !== true) {
	while (!window[variable]) {
		await new Promise(resolve => requestAnimationFrame(resolve));
	}

	return variable;
};

export const checkElement2 = async selector => {
	while (document.querySelector(selector) === null) {
		await new Promise(resolve => requestAnimationFrame(resolve));
	}

	return document.querySelector(selector);
};

export const checkElement2WithBoundingRect = async (selector, minimalWidth) => {
	while (
		document.querySelector(selector) === null ||
		document.querySelector(selector).getBoundingClientRect().width < minimalWidth
	) {
		await new Promise(resolve => requestAnimationFrame(resolve));
	}

	return document.querySelector(selector);
};

export const getClassesFromComponents = component => {
	try {
		let { className = '' } = component?.getView().el || {};
		if (typeof className !== 'string') {
			// console.log(
			// 	'getClassesFromComponents not string',
			// 	typeof className,
			// 	className.constructor.name
			// );
			if (typeof className === 'object') {
				className = `${className.constructor.name}`;
			} else {
				className = `${className}`;
			}
		}
		return className;
	} catch (e) {
		console.log(e);
	}
	return '';
};

export const moveElement = (oldParentSelector, newParentSelector) => {
	const newParent = document.querySelector(newParentSelector);
	const oldParent = document.querySelector(oldParentSelector);

	while (oldParent.childNodes.length > 0) {
		newParent.appendChild(oldParent.childNodes[0]);
	}
};

export const hideElement = elementSelector => {
	checkElement2(elementSelector).then(element => {
		element.style.display = 'none';
	});
	// const element = document.querySelector(elementSelector);
	// if (element) element.style.display = 'none';
};

export const showElement = (elementSelector, displayStyle = 'block') => {
	checkElement2(elementSelector).then(element => {
		element.style.display = displayStyle;
	});
	// const element = document.querySelector(elementSelector);
	// if (element) element.style.display = 'none';
};

export const addClassElement = (elementSelector, className) => {
	checkElement2(elementSelector).then(element => {
		element.classList.add(className);
	});
};

export const clickElement = elementSelector => {
	checkElement2(elementSelector).then(element => {
		element.click();
	});
	// document.querySelector(elementSelector).click();
};

export const wrap = (el, wrapper) => {
	el.parentNode.insertBefore(wrapper, el);
	wrapper.appendChild(el);
};

export const getMousePosition = event => {
	let eventDoc;
	let doc;
	let body;

	event = event || window.event; // IE-ism

	// If pageX/Y aren't available and clientX/Y are,
	// calculate pageX/Y - logic taken from jQuery.
	// (This is to support old IE)
	if (event.pageX == null && event.clientX != null) {
		eventDoc = (event.target && event.target.ownerDocument) || document;
		doc = eventDoc.documentElement;
		body = eventDoc.body;

		event.pageX =
			event.clientX +
			((doc && doc.scrollLeft) || (body && body.scrollLeft) || 0) -
			((doc && doc.clientLeft) || (body && body.clientLeft) || 0);
		event.pageY =
			event.clientY +
			((doc && doc.scrollTop) || (body && body.scrollTop) || 0) -
			((doc && doc.clientTop) || (body && body.clientTop) || 0);
	}
	const left = event.pageX;
	const top = event.pageY;
	return {
		left,
		top
	};
};

export const addLinkToDOM = (dom, linkOptions) => {
	const element = document.createElement('link');
	if (linkOptions.type) element.type = linkOptions.type;
	element.rel = linkOptions.rel;
	element.href = linkOptions.href;
	dom.appendChild(element);
};

export const addCSSFileToDOM = (cssLink, parent) => {
	addLinkToDOM(parent, {
		type: 'text/css',
		rel: 'stylesheet',
		href: cssLink
	});
};

export const findGrapesJSComponents = (
	selector,
	parent = window.grapesjs.DomComponents.getWrapper()
) => {
	const comps = parent.find(selector);
	return comps;
};

export const findGrapesJSComponent = (
	selector,
	parent = window.grapesjs.DomComponents.getWrapper()
) => {
	const components = findGrapesJSComponents(selector, parent);
	if (components.length > 0) {
		return components[0];
	}
	return null;
};

export const applyTextIntoSelector = (
	selector,
	text,
	parent = window.grapesjs.DomComponents.getWrapper()
) => {
	const component = findGrapesJSComponent(selector, parent);
	if (component && component.is('text')) {
		component.set('content', text);
		return true;
	}
	return false;
};

export function searchNodeTreeByTextContent(element, text) {
	if (!element) {
		return null;
	}
	if (element.innerHTML.trim() === text) {
		return element;
	}
	if (element.children != null) {
		let result = null;
		// eslint-disable-next-line no-plusplus
		for (let i = 0; result == null && i < element.children.length; i++) {
			result = searchNodeTreeByTextContent(element.children[i], text);
			if (result) {
				break;
			}
		}
		return result;
	}
	return null;
}

export const setStyleGrapesJSComponent = (selector, obj, omitStyles = []) => {
	const comp = findGrapesJSComponents(selector)[0];
	console.log('setStyleGrapesJSComponent', comp);
	if (comp) {
		const mergedStyles = {
			...comp.getStyle(),
			...obj
		};
		// console.log('setStyleGrapesJSComponent mergedStyles', mergedStyles);
		omitStyles.forEach(eachOmit => {
			delete mergedStyles[eachOmit];
		});
		// console.log('setStyleGrapesJSComponent omit', mergedStyles);
		comp.setStyle(mergedStyles);
	}

	return comp;
};

export const setStyleGrapesJSComponentUsingAddStyle = style => {
	// console.log('setStyleGrapesJSComponentUsingAddStyle', style);
	window.grapesjs.addComponents(
		`<style>		
						${style}
    			</style>`
	);
};

export const setStyleGrapesJSComponents = (selector, obj) => {
	const comps = findGrapesJSComponents(selector);
	comps.forEach(comp => {
		console.log('setStyleGrapesJSComponent', comp);
		comp.setStyle({
			...comp.getStyle(),
			...obj
		});
	});
};

export const getStyleGrapesJSComponent = (selector, key) => {
	const comp = findGrapesJSComponents(selector)[0];
	// console.log('getStyleGrapesJSComponent', comp);
	if (comp) {
		// comp.set('style', obj);
		const style = comp.getStyle();
		return style[key];
	}

	return null;
};

export const removeAttributeGrapesJSComponent = (selector, name) => {
	const comp = findGrapesJSComponents(selector)[0];
	if (comp) {
		const attr = comp.getAttributes();
		delete attr[name];
		comp.setAttributes(attr);
	}

	return comp;
};

export const setAttributeGrapesJSComponent = (selector, obj) => {
	const comp = findGrapesJSComponents(selector)[0];
	console.log('setAttributeGrapesJSComponent', comp, obj);
	if (comp) {
		const attr = comp.getAttributes();
		comp.setAttributes({
			...attr,
			...obj
		});
	}

	return comp;
};

export const hideSrcFromImageGrapesJSComponent = selector => {
	const comp = findGrapesJSComponents(selector)[0];
	if (comp) {
		const attr = comp.getAttributes();
		comp.setAttributes({
			...attr,
			src:
				'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII='
		});
	}

	return comp;
};

export const setContentGrapesJSComponent = (selector, content) => {
	const comps = findGrapesJSComponents(selector);
	comps.forEach(comp => {
		// console.log('setContentGrapesJSComponent', selector, content);
		// comp.set('content', content);
		comp.components(content);
	});
};

export const getContentGrapesJSComponent = selector => {
	const comp = findGrapesJSComponent(selector);
	if (comp) {
		return comp.attributes.content.trim();
	}
	return '';
};

export const getAttributeGrapesJSComponent = (selector, attributeName) => {
	const comp = findGrapesJSComponent(selector);
	if (comp) {
		console.log('getAttributeGrapesJSComponent', comp.attributes, attributeName);
		return comp.attributes.attributes[attributeName] || '';
	}
	return '';
};

export const removeGrapesJSComponents = selector => {
	const comps = findGrapesJSComponents(selector);
	comps.forEach(comp => {
		comp.remove();
	});
};

export const setFontFamilyGrapesJS = (cssRule, fontFamily) => {
	if (!fontFamily) return;
	// set new font family
	window.grapesjs.addComponents(
		`<link href="https://fonts.googleapis.com/css2?family=${fontFamily}&display=swap" rel="stylesheet">`
	);
	window.grapesjs.addComponents(
		`<style>
    ${cssRule} {
        font-family: "${fontFamily}"
    }    
    </style>`
	);
	// setStyleGrapesJSComponent(cssRule, { 'font-family': `"${fontFamily}"` });
};

export const hideGrapesJSComponent = comp => {
	if (comp) {
		comp.setStyle({
			...comp.getStyle(),
			display: 'none'
		});
	}
};

export const hideGrapesJSComponents = comps => {
	comps.forEach(comp => {
		hideGrapesJSComponent(comp);
	});
};

export const showGrapesJSComponent = comp => {
	if (comp) {
		comp.setStyle({
			...comp.getStyle(),
			display: 'block'
		});
	}
};

export const showGrapesJSComponents = comps => {
	comps.forEach(comp => {
		showGrapesJSComponent(comp);
	});
};

export const showInlineBlockGrapesJSComponent = comp => {
	if (comp) {
		comp.setStyle({
			...comp.getStyle(),
			display: 'inline-block'
		});
	}
};

export const showFlexGrapesJSComponent = comp => {
	if (comp) {
		comp.setStyle({
			...comp.getStyle(),
			display: 'flex'
		});
	}
};

export const getAllComponents = component => {
	component = component || window.grapesjs.DomComponents.getWrapper();

	let components = component.get('components').models;
	component.get('components').forEach(function(comp) {
		components = components.concat(getAllComponents(comp));
	});

	return components;
};

export const getAllComponents2 = component => {
	const getAllComponents_ = (model, result = []) => {
		result.push(model);
		model.components().each(mod => getAllComponents_(mod, result));
		return result;
	};

	component = component || window.grapesjs.DomComponents.getWrapper();
	const all = getAllComponents_(component);
	return all;
};

export const setReadOnlyComponent = (component, draggable = false) => {
	component.set({
		editable: false,
		removable: false,
		draggable,
		selectable: draggable,
		hoverable: draggable,
		copyable: false,
		stylable: false
		// propagate: ['editable', 'removable', 'draggable', 'copyable', 'selectable',
		// 'stylable', 'hoverable']
	});
};

export const setDraggableComponent = (component, draggable = false) => {
	component.set({
		draggable
	});
};

export const setAllComponentsReadOnlyButTextAndImage = () => {
	console.log('setAllComponentsReadOnlyButTextAndImage');
	const allComps = getAllComponents2();
	allComps.forEach(comp => {
		const className = getClassesFromComponents(comp);
		// console.log('setAllComponentsReadOnlyButTextAndImage', className);
		if (
			!(
				comp.is('text') ||
				// || comp.is('image')
				className.includes('backToTop') ||
				comp.getId() === 'wrapper'
			)
		) {
			setReadOnlyComponent(comp);
		} else {
			setDraggableComponent(comp, false);
		}
	});
};

export const setEditableComponent = (component, draggable) => {
	component.set({
		editable: true,
		removable: true,
		draggable,
		selectable: true,
		hoverable: true,
		copyable: true,
		stylable: true
	});
};

export const autoClickFirstImageComponent = () => {
	setTimeout(() => {
		// Auto click first dom elements to show settings
		const allComps = getAllComponents();
		for (let i = 0; i < allComps.length; i += 1) {
			if (allComps[i].is('image')) {
				window.grapesjs.select(allComps[i]);
				break;
			}
		}
	}, 0);
};

export const iFrameScrollTo = sectionId => {
	console.log(
		sectionId,
		document.querySelector('.gjs-frame'),
		document.querySelector('.gjs-frame').contentWindow
	);
	document.querySelector('.gjs-frame').contentWindow.scrollTo(sectionId);
};

export const showHideTopMenu = (sectionId, isShown) => {
	// Also should hide menu too
	let comp = findGrapesJSComponent(`a[href="${sectionId}"]`);
	if (comp) {
		comp = comp.parent();
		if (comp) {
			if (isShown) {
				showFlexGrapesJSComponent(comp);
			} else {
				hideGrapesJSComponent(comp);
			}
		}
	}
};

export const iFrameShowHide = (sectionId, isShown) => {
	// console.log('iFrameShowHide', sectionId, isShown);
	const comp = findGrapesJSComponent(sectionId);
	if (comp) {
		if (isShown) {
			showGrapesJSComponent(comp);
		} else {
			hideGrapesJSComponent(comp);
		}
	}

	// Also should hide menu too
	showHideTopMenu(sectionId, isShown);

	// const sectionElement = document
	//   .querySelector('.gjs-frame')
	//   .contentDocument.querySelector(sectionId);
	// console.log('iFrameShowHide', sectionId, isShown);
	// if (!sectionElement) return;
	// if (isShown) {
	//   sectionElement.style.display = 'block';
	// } else {
	//   sectionElement.style.display = 'none';
	// }
};

export const getSectionsFromHTML = () => {
	const sections = [];
	const comps = findGrapesJSComponents('a[href*="#section-"]');
	comps.forEach(comp => {
		const id = comp.attributes.attributes.href;
		const title = getDefaultTitleForSections(id, comp.attributes.content);

		// console.log('getSectionsFromHTML', title, id, comp);

		const aComp = findGrapesJSComponent(`${id}`);
		const order = aComp?.getStyle().order || '0';
		// console.log('getSectionsFromHTML', order);

		sections.push({ id, title, order });
		// console.log('getSectionsFromHTML', sections);
		// }
	});
	console.log('getSectionsFromHTML', sections);
	// now sort sections base on order
	sections.sort(function(a, b) {
		return parseInt(a.order, 10) - parseInt(b.order, 10);
	});

	return sections;
};

export const getWidgetsFromHTML = () => {
	let sections = [];
	const comps = findGrapesJSComponents('div[id*="widget-"]');
	comps.forEach(comp => {
		const id = comp.getId();
		sections.push(id);
	});
	// Default 2 widgets
	if (sections.length === 0) {
		sections = ['widget-edu', 'widget-insurance'];
	}
	return sections;
};

export const setHrefGrapesJSComponent = (selector, href) => {
	// if (href === undefined) return;
	const comps = findGrapesJSComponents(selector);
	comps.forEach(comp => {
		if (href) {
			showInlineBlockGrapesJSComponent(comp);

			let hrefFinal = href?.trim();
			if (hrefFinal) {
				if (selector.includes('whatsapp')) {
					hrefFinal = getWhatsappUniversalLink(hrefFinal);
				} else if (selector.includes('telegram')) {
					hrefFinal = getTelegramUniversalLink(hrefFinal);
				} else {
					hrefFinal = getSocialMediaLinks(hrefFinal);
				}
				comp.setAttributes({ href: hrefFinal });
			} else {
				comp.setAttributes({ href: '' });
			}
		} else {
			// remove social
			hideGrapesJSComponent(comp);
		}
	});
};

export const addChildComponentsGrapesJS = (selector, html) => {
	const comp = findGrapesJSComponents(selector)[0];
	if (comp) {
		comp.components(html);
	}
};

export const addComponentInsideEditor = componentObj => {
	const wrapperCoverImageComponent = findGrapesJSComponent('.cover-page');
	const randomTop = getRandomInt(4, 25);
	const randomLeft = getRandomInt(4, 25);
	const newStyle = {
		...componentObj.style,
		position: 'absolute',
		top: `${randomTop}vh`,
		left: `${randomLeft}vw`
	};
	const result = wrapperCoverImageComponent.components().add({
		...componentObj,
		style: newStyle,
		attributes: {
			'data-image-props': '{"width": 400, "height": 400}'
		}
	});
	return result;
};

export const addTextComponentInsideEditor = (additionClass = [], type, attributes) => {
	const fontSize = type === 'header' ? '2rem' : '1.5rem';
	const componentObj = {
		type: 'text',
		...attributes,
		content: `Insert your text here`,
		style: { height: 'auto', width: '35vw', 'font-size': fontSize, color: 'black' }
	};

	const result = addComponentInsideEditor(componentObj);
	result.addClass(additionClass);
};

export const addImageComponentInsideEditor = (classes, attributes) => {
	const componentObj = {
		type: 'image',
		...attributes,
		style: {
			width: '35vw',
			height: '35vw'
			// width: '400px',
			// height: '400px'
		}
	};
	const result = addComponentInsideEditor(componentObj);
	result.addClass(classes);
};

export const setAllChildComponentsReadOnly = (selector, exceptions = []) => {
	const comps = findGrapesJSComponents(selector);
	comps.forEach(comp => {
		// console.log('setAllChildComponentsReadOnly', comp);
		const allChild = getAllComponents2(comp);
		// console.log('setAllChildComponentsReadOnly allChild', allChild);
		allChild.forEach(child => {
			let isException = false;
			if (exceptions.length > 0) {
				const className = getClassesFromComponents(child);
				// console.log('setAllChildComponentsReadOnly child', { selector, className });
				exceptions.forEach(exception => {
					if (className?.includes(exception)) {
						isException = true;
					}
				});
			}
			if (isException) {
				setEditableComponent(child);
			} else {
				setReadOnlyComponent(child);
			}
		});
	});
};

export const removeComponentFromModel = model => {
	model.collection.remove(model);
};

export const getElementsFromIframe = (frameSelector, elementSelector) => {
	console.log('getElementsFromIframe', frameSelector, elementSelector);
	const iframe = document.querySelector(frameSelector);
	const elmnts = iframe.contentWindow.document.querySelectorAll(elementSelector);
	return elmnts;
};

export const getElementFromIframe = (frameSelector, elementSelector) => {
	console.log('getElementFromIframe', frameSelector, elementSelector);
	const iframe = document.querySelector(frameSelector);
	const element = iframe.contentWindow.document.querySelector(elementSelector);
	return element;
};

export const removeElementsFromIframe = (frameSelector, elementSelector) => {
	const hoveredImageElements = getElementsFromIframe(frameSelector, elementSelector);
	// console.log('hoveredImageElement', component?.getId());
	u(hoveredImageElements).remove();
};

export const removeAddClassElement = (selector, removeClass, addClass) => {
	const element = document.querySelector(selector);
	element?.classList?.remove(removeClass);
	element?.classList?.add(addClass);
};

export const getWindowWidthHeight = () => {
	const windowWidth =
		window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
	const windowHeight =
		window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
	return { windowWidth, windowHeight };
};
